import { Injectable, TemplateRef } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ToastService {
  toasts: any[] = [];

  show(textOrTpl: string | TemplateRef<any>, options: any = {}) {
    this.toasts = [];
    this.toasts.push({ textOrTpl, ...options });
    setTimeout(() => {
      this.remove();      
    }, 100000000);
  }

  remove() {
    
    this.toasts = [];
    // this.toasts = this.toasts.filter(t => t !== toast);

  }
}
